module.exports = __webpack_public_path__ + "media/images/ohap_announcement_off-d453253284bf68d5c565b5088ae3ea44.png";